import {type NestedPartial} from '../GameStateTypeUtils.ts'
import {type PlayerColor} from '../PlayerState.ts'
import {type CardEnum} from '../CardState.ts'
import {type TradeId} from './TradeState.ts'

export enum TradeResponseStatus {
    PendingResponse = 0,
    Accepted = 1,
    Rejected = 2,
    Embargoed = 3,
}

export interface TradeOfferState {
    readonly id: TradeId
    readonly creator: PlayerColor
    readonly offeredResources: CardEnum[]
    readonly wantedResources: CardEnum[]

    readonly counterOfferInResponseToTradeId: TradeId | undefined

    readonly playersCreatingCounterOffer: {[key in PlayerColor]?: boolean}
    readonly playerResponses: {[key in PlayerColor]?: TradeResponseStatus}

    readonly forcedResponse?: TradeResponseStatus
}

export function isFullTradeState(tradeState: NestedPartial<TradeOfferState>): tradeState is TradeOfferState {
    const requiredKeys: (keyof TradeOfferState)[] = [
        'id',
        'creator',
        'offeredResources',
        'wantedResources',
        'playersCreatingCounterOffer',
        'playerResponses',
    ]

    return requiredKeys.every((key) => tradeState[key] !== undefined)
}
